import { ACTION_TYPES, STATUS_TYPES, Story } from '@shared/api/types/story';

export const magicstoreZnsConnect: Story = {
  id: 'magicstore-zns-connect',
  type: 'SOQUEST',
  status: STATUS_TYPES.ACTIVE,
  name: 'Magic Store ZNS connect',
  index: 0,
  content: {
    type: ACTION_TYPES.SOQUEST,
    metadata: {
      title: 'Magic Store Campaign: Earn 0.1 MATIC in the ZNS Campaign',
      description:
        'Join the web3 world at Magic Store by Magic Square. Earn 0.1 MATIC by following ZNS on their socials',
      keywords:
        'Web3, Crypto, Hot Offer, Magic Store, Magic Square, ZNS Connect Campaign, MATIC, Web3 App Store, Decentralized Apps, Crypto Rewards, Blockchain, DApps, Win Crypto, Digital Assets, Web3 Technology',
    },
    config: {
      key: 'a2ecf4d4d467b8a630017f9169ca3e32cf6e',
      scode: 'MagicSquare',
      ccode: '9gpb6mv7gN',
    },
  },
};
